import { jsx } from 'react/jsx-runtime';
import { fadeInAnimation, Backdrop as Backdrop$1, conditionalInclude, Flex, themedColor, font, Box, useBodyScrollLock, isSsr } from '@lemonade-hq/cdk';
import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled, { keyframes, css } from 'styled-components';
import { DeleteIcon } from '../Icons/Icons.esm.js';
import { rounded } from '../../styles/common.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    0% {\n        opacity: 0;\n        transform: scale(0.3)\n    }\n    100% {\n        opacity: 1;\n        transform: scale(1)\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  animation: ",
        " 0.2s ease-in-out;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  animation: ",
        " 0.2s ease-in-out;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n    ",
        "\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  background-color: rgba(38, 38, 38, 0.8);\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  flex: 0 1 auto;\n  background-color: ",
        ";\n  color: ",
        ";\n  z-index: 1300;\n  position: relative;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  width: 30px;\n  height: 30px;\n  cursor: pointer;\n\n  svg {\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
var SLOT_ID = "portal-slot";
var addSlot = function() {
    var slotEl = document.querySelector("#".concat(SLOT_ID));
    var createSlotEl = function() {
        var slot = document.createElement("div");
        slot.id = SLOT_ID;
        // eslint-disable-next-line unicorn/prefer-dom-node-append
        return document.body.appendChild(slot);
    };
    return slotEl !== null && slotEl !== void 0 ? slotEl : createSlotEl();
};
var DialogPortal = function(param) {
    var children = param.children;
    if (isSsr()) return null;
    var slotElement = addSlot();
    return /*#__PURE__*/ ReactDOM.createPortal(children, slotElement);
};
var modalAnimation = keyframes(_templateObject());
var backdropHiddenStyles = css(_templateObject1());
var backdropAnimationStyles = css(_templateObject2(), fadeInAnimation());
var contentAnimationStyles = css(_templateObject3(), modalAnimation);
var DialogBackdrop = styled(Backdrop$1)(_templateObject5(), function(props) {
    return css(_templateObject4(), conditionalInclude(props.isHidden, backdropHiddenStyles), conditionalInclude(!props.isHidden, backdropAnimationStyles));
});
var DialogContent = styled(Flex)(_templateObject7(), rounded, themedColor("white"), themedColor("night"), function(props) {
    return css(_templateObject6(), conditionalInclude(!props.isHidden, contentAnimationStyles));
});
var DialogHeader = styled(Flex)(_templateObject8(), font("main", {
    fontSize: "1.6rem",
    lineHeight: "1.9rem",
    fontWeight: 700
}));
var DialogBody = styled(Flex)(_templateObject9(), font("main", {
    fontSize: "1.6rem",
    lineHeight: "1.9rem",
    fontWeight: 700
}));
var CloseXContainer = styled(Box)(_templateObject10());
/**
 * @deprecated use Dialog & DialogContext instead
 */ var CloseIcon = function(param) {
    var className = param.className, onClose = param.onClose;
    var onCloseIconClicked = function(e) {
        if (onClose == null) return;
        if (e.target !== e.currentTarget) {
            return;
        }
        e.preventDefault();
        onClose();
    };
    return /*#__PURE__*/ jsx(CloseXContainer, {
        className: className,
        onClick: onCloseIconClicked,
        children: /*#__PURE__*/ jsx(DeleteIcon, {})
    });
};
/**
 * @deprecated use Dialog & DialogContext instead
 */ var Header = function(_param)  {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return jsx(DialogHeader, _object_spread_props(_object_spread({
        alignItems: "center",
        justifyContent: "center"
    }, props), {
        children: children
    }));
};
/**
 * @deprecated use Dialog & DialogContext instead
 */ var Body = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    var ref = useRef(null);
    useBodyScrollLock({
        element: ref.current
    });
    return /*#__PURE__*/ jsx(DialogBody, _object_spread_props(_object_spread({
        alignItems: "center",
        justifyContent: "center",
        ref: ref
    }, props), {
        children: children
    }));
};
/**
 * @deprecated use Dialog & DialogContext instead
 */ var Footer = function(_param)  {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return jsx(Flex, _object_spread_props(_object_spread({
        alignItems: "center",
        justifyContent: "center"
    }, props), {
        children: children
    }));
};
/**
 * @deprecated use Dialog & DialogContext instead
 */ var Content = function(_param)  {
    var children = _param.children, isHidden = _param.isHidden, onClose = _param.onClose, props = _object_without_properties(_param, [
        "children",
        "isHidden",
        "onClose"
    ]);
    return jsx(DialogContent, _object_spread_props(_object_spread({
        alignItems: "center",
        flexDirection: "column",
        isHidden: isHidden !== null && isHidden !== void 0 ? isHidden : false,
        justifyContent: "center",
        px: [
            "20px",
            "40px"
        ],
        py: [
            "30px",
            "40px"
        ]
    }, props), {
        children: React.Children.map(children, function(child) {
            return /*#__PURE__*/ React.cloneElement(child, {
                onClose: onClose
            });
        })
    }));
};
/**
 * @deprecated use Dialog & DialogContext instead
 */ var Backdrop = function(_param) {
    var children = _param.children, className = _param.className, _param_isHidden = _param.isHidden, isHidden = _param_isHidden === void 0 ? false : _param_isHidden, onClose = _param.onClose, _param_backdropClose = _param.backdropClose, backdropClose = _param_backdropClose === void 0 ? true : _param_backdropClose, styledProps = _object_without_properties(_param, [
        "children",
        "className",
        "isHidden",
        "onClose",
        "backdropClose"
    ]);
    var onBackdropClicked = function(e) {
        if (onClose == null || !backdropClose) return;
        if (e.target !== e.currentTarget) {
            return;
        }
        e.preventDefault();
        onClose();
    };
    return /*#__PURE__*/ jsx(DialogBackdrop, _object_spread_props(_object_spread({
        className: className,
        disablesBodyScroll: !isHidden,
        isHidden: isHidden,
        onClick: onBackdropClicked
    }, styledProps), {
        children: React.Children.map(children, function(child) {
            return /*#__PURE__*/ React.cloneElement(child, {
                className: className,
                isHidden: isHidden,
                onClose: onClose
            });
        })
    }));
};
/**
 * @deprecated use Dialog & DialogContext instead
 */ var LegacyDialog = function(_param) {
    var children = _param.children, onClose = _param.onClose, historyHash = _param.historyHash, _param_isHidden = _param.isHidden, isHidden = _param_isHidden === void 0 ? false : _param_isHidden, _param_enableHistory = _param.enableHistory, enableHistory = _param_enableHistory === void 0 ? false : _param_enableHistory, props = _object_without_properties(_param, [
        "children",
        "onClose",
        "historyHash",
        "isHidden",
        "enableHistory"
    ]);
    useEffect(function() {
        if (!enableHistory) return undefined;
        window.location.hash = historyHash !== null && historyHash !== void 0 ? historyHash : "open";
        window.addEventListener("popstate", function() {
            onClose();
        });
        return function() {
            window.addEventListener("popstate", function() {});
        };
    }, [
        enableHistory,
        onClose,
        historyHash
    ]);
    return /*#__PURE__*/ jsx(DialogPortal, {
        children: React.Children.map(children, function(child) {
            return /*#__PURE__*/ React.cloneElement(child, _object_spread({
                isHidden: isHidden,
                onClose: onClose
            }, props));
        })
    });
};
/* EXPORTS ******************************************************************/ LegacyDialog.Backdrop = Backdrop;
LegacyDialog.CloseIcon = CloseIcon;
LegacyDialog.Content = Content;
LegacyDialog.Header = Header;
LegacyDialog.Body = Body;
LegacyDialog.Footer = Footer;

export { LegacyDialog, Backdrop as LegacyDialogBackdrop, Body as LegacyDialogBody, CloseIcon as LegacyDialogCloseIcon, Content as LegacyDialogContent, Footer as LegacyDialogFooter, Header as LegacyDialogHeader };
